import { useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { observer } from 'mobx-react'

import { GLOBAL_ROUTE_PATHS } from 'Router/Router.constants'

import { Banner } from 'Components/_theme'

import { composePath } from 'Portal/src/utilities/composePath/composePath.util'

import { Heading } from '../Heading/Heading'
import { BANNER_VERSION, IMAGE_URL } from './Banner.constants'

export const BannerPresentation = observer(() => {
  const history = useHistory()
  const { employeeId } = useParams<{ employeeId: string }>()

  const handleNewOrderButtonClick = useCallback(() => {
    history.push(
      composePath({
        params: { employeeId },
        path: GLOBAL_ROUTE_PATHS.employee.orderNew,
      }),
    )
  }, [employeeId, history])

  const renderBanner = () =>
    BANNER_VERSION.map(version => (
      <Banner
        buttonText="Discover offers now"
        className="ms-6"
        imageSource={IMAGE_URL}
        onButtonClick={handleNewOrderButtonClick}
        showButton
        text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vulputate tincidunt sed ornare id malesuada amet. "
        title="Managing Company Devices"
        version={version}
      />
    ))

  return (
    <div>
      <Heading className="pt-4" size={4}>
        Banner:
      </Heading>

      {/* *** Banner *** */}

      <div className="d-flex pt-4 ms-n4">{renderBanner()}</div>
    </div>
  )
})
